export const LOCALE_PREFIX = 'components.Dialog.components.GroupMonitoring.components.GroupMonitoringForm'

export const SENDING_FREQUENCY_DEFINITIONS = [
    { label: 'noNotifi', value: 'no' },
    { label: 'dailyNotifi', value: 'daily' },
    { label: 'weeklyNotifi', value: 'weekly' },
    { label: 'monthlyNotifi', value: 'monthly' },
]

export const SENDING_METHOD_DEFINITIONS = [
    { label: 'inlineHTML', value: 'INLINE_HTML' },
    { label: 'attachedCSV', value: 'ATTACHED_CSV' },
    { label: 'attachedXLS', value: 'ATTACHED_XLS' },
]

export const FORM_KEY = 'groupMonitoringForm'

export const FORM_FIELDS = [
    'recipients',
    'sendingFrequency',
    'sendingMethod',
    'sendingWFrequencySelection',
    'sendingMFrequencySelection',
]
